<template>
  <div>
    <h1 class="page-header">{{ $t('defaultcreditday.defaultCreditDay') }}</h1>
    <ts-card>
      <ts-card-wrapper> </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources.length ? resources : resource"
        :loading="loading"
      >
        <template v-slot="{ record }">
          <td>
            <span v-if="!updating">{{ record.credit_day }}</span>
            <input
              v-model.number="model.credit_day"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': errors.has('credit_day') }"
              :placeholder="$t('defaultcreditday.enterCreditDay')"
              v-if="updating"
            />
          </td>
          <td class="kh-font">
            <span v-if="!updating">{{ record.description }}</span>
            <input
              v-model="model.description"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('description') }"
              :placeholder="$t('defaultcreditday.leaveyourdescriptionhere')"
              v-if="updating"
            />
          </td>
          <td class="text-center">
            <ts-button
              v-if="updating"
              class="btn-xs btn-primary mr-2"
              @click="update(record)"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-save" v-else></i>
            </ts-button>
            <ts-button
              @click="cancel"
              v-if="updating"
              class="btn-xs btn-default"
            >
              <i class="fa fa-times"></i>
            </ts-button>
            <a
              href="#"
              title="edit"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
              v-if="!updating"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'default-credit-day',
  data() {
    return {
      loading: false,
      updating: false,
      model: {
        company_id: 0,
        credit_day: '',
        description: ''
      },
      columns: [
        { name: this.$t('defaultcreditday.creditDay') },
        { name: this.$t('defaultcreditday.description') },
        {
          name: this.$t('defaultcreditday.action'),
          style: 'text-align:center; width:7%'
        }
      ],
      resource: [
        {
          company_id: 0,
          credit_day: 0,
          description: '',
          _deleting: false
        }
      ],

      errors: new Errors()
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('defaultCreditDay', ['resources', 'edit_data'])
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('defaultCreditDay/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.updating = true
      this.model = {
        company_id: record.company_id,
        credit_day: record.credit_day,
        description: record.description
      }
    },
    update(record) {
      record._deleting = true
      this.$store
        .dispatch('defaultCreditDay/update', Object.assign({}, this.model))
        .then(response => {
          this.cancel()
          record._deleting = false
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          record._deleting = false
        })
    },
    cancel() {
      this.updating = false
      this.errors = new Errors()
      this.model = {
        company_id: '',
        credit_day: '',
        description: ''
      }
    }
  }
}
</script>

<style lang="css" scoped>
table td {
	vertical-align : middle;
  color: #456BA5;
}
</style>
